import React, {useCallback, useMemo, useState} from 'react';
import {
  Breadcrumbs,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@material-ui/core";
import {useAccounts} from "../../../hooks/useAccounts";
import _ from "lodash";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import {Account} from "../../../api/api";

export const AccountsPage = () => {
  const {accounts} = useAccounts()
  const [selected, setSelected] = useState<Account[]>([])

  const rootAccounts = useMemo(() => {
    return _.filter(accounts, a => !a.parentId)
  }, [accounts])

  const viewAccounts = useMemo(() => {
    const out = _.map(_.takeRight(selected, 3), a => {
      return _.filter(accounts, a2 => a2.parentId === a.id)
    })
    if (out.length === 3) {
      return out
    } else {
      return [rootAccounts, ...out]
    }
  }, [accounts, rootAccounts, selected])

  const onSelect = useCallback( (col: number, account: Account) => () => {
    const taking = selected.length >= 2 ? col + selected.length - 2 : col
    setSelected([..._.take(selected, taking), account])
  }, [selected])

  return (
    <>
      <Typography variant='h4'>Accounts</Typography>
      <Breadcrumbs aria-label="breadcrumb">
        <Link color="inherit" component={Button} onClick={() => setSelected([])}>
          root
        </Link>
        {_.map(selected, (s, i) => (
          <Link key={'Breadcrumbs-'+i} color="inherit" component={Button} onClick={onSelect(i, s)}>
            {s.name}
          </Link>
        ))}
      </Breadcrumbs>
      <Grid container spacing={5}>
        {
          viewAccounts.map((column, i) => (
            <Grid key={`col-${i}`} item md={4}>
              <List>
                {column?.map((a) => (
                  <ListItem key={a.id} button onClick={onSelect(i, a)}>
                    <ListItemText primary={a.name} secondary={"broker: " + a.broker} />
                    <ListItemIcon>
                      <ChevronRightIcon />
                    </ListItemIcon>
                  </ListItem>
                ))}
              </List>
            </Grid>
          ))
        }
      </Grid>
    </>
  );
};


